import { render, staticRenderFns } from "./TentangAplikasi.vue?vue&type=template&id=65e23c66&"
import script from "./TentangAplikasi.vue?vue&type=script&lang=js&"
export * from "./TentangAplikasi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TentangAplikasi.vue"
export default component.exports